import { MutationTree } from 'vuex';
import { LivePushStatus, LIVE_STATUS } from '@panda/cache/src/live/define';
import {
  LiveMemberInfo, LiveTeacherInfo,
} from '@/define/Live';
import { LiveState, MySpeakStatus } from './types';

const mutations: MutationTree<LiveState> = {
  setLiveAccount(state, account: string) {
    state.liveAccount = account;
  },

  setMine(state, payload: LiveMemberInfo) {
    state.mine = { ...state.mine, ...payload };
    if (window.LIVE_INTEGRAL) {
      window.localStorage.setItem(window.LIVE_INTEGRAL, String(state.mine.integral));
    }
  },

  setTeacher(state, payload: LiveTeacherInfo) {
    state.teacher = {
      ...state.teacher,
      ...payload,
    };
  },

  addClassmate(state, payload: LiveMemberInfo) {
    if (payload.account === state.mine.account) {
      return;
    }
    if (payload.isTeacher) { // 目前老师不会加入加入该列表
      state.teacher = { ...state.teacher, ...payload };
      return;
    }
    const targetClassmate = state.classmates.find((member) => member.account === payload.account);
    if (targetClassmate) {
      Object.assign(targetClassmate, payload);
    } else {
      state.classmates.push(payload);
    }
  },

  removeClassmate(state, account: string) {
    const targetIndex = state.classmates.findIndex((member) => member.account === account);
    if (targetIndex !== -1) {
      state.classmates.splice(targetIndex, 1);
    }
  },

  notifyVideoStreamEnter(state, account: string) {
    if (account === state.teacher.account) {
      state.teacher = { ...state.teacher, hasCamera: true };
    }
    if (account === state.speaker.account) {
      state.speaker = { ...state.speaker, hasCamera: true };
    }
  },

  notifyVideoStreamLeave(state, account: string) {
    if (account === state.teacher.account) {
      state.teacher = { ...state.teacher, hasCamera: false };
    }
    if (account === state.speaker.account) {
      state.speaker = { ...state.speaker, hasCamera: false };
    }
  },

  updateLiveStatus(state, { liveStatus }: { liveStatus: LIVE_STATUS }) {
    state.liveStatus = liveStatus;
  },

  updatePushStatus(state, payload: LivePushStatus) {
    state.pushStatus = payload;
  },

  updateMySpeakStatus(state, payload: MySpeakStatus) {
    state.mySpeakStatus = { ...state.mySpeakStatus, ...payload };
  },

  updateSpeakStatus(state, { isAllow }: { isAllow: boolean }) {
    state.allowSpeak = isAllow;
  },

  updateCurrentSpeaker(state, speaker: LiveMemberInfo) {
    state.speaker = { ...speaker, hasCamera: false };
  },

  updateTeacherStatus(state, payload) {
    state.teacherStatus = payload;
  },

};

export default mutations;
